<template>
  <div class="column-video">
    <div v-for="(data, index) in datas" :key="index">
      <div class="title">
        {{ data.tags }}
      </div>
      <div class="content">
        <div class="content-img">
          <img :src="data.img" alt @click="watch(data, index)" />
          <div
            :class="data.is_watch == 0 ? 'play' : 'replay'"
            @click="watch(data, index)"
          ></div>
          <div class="watched" v-show="data.is_watched == 1">
            {{ $t("columnVideo.Watched") }}
          </div>
        </div>
        <h1>{{ data.name }}</h1>
        <h2 class="over-hide">
          {{ data.author }}
          <i v-if="data.author != ''">|</i>
          {{ data.category_name }}
        </h2>
        <div class="showtotal detailed-introduce">
          <div class="intro-content" ref="desc" :title="data.info">
            <span class="merchant-desc" v-text="data.info"></span>
          </div>
        </div>
        <div class="fold" @click="showTotalIntro(index)">
          <i></i>
          <span>{{ $t("columnVideo.more") }}</span>
        </div>
        <div class="info">
          <h4>{{ data.publish_at }}</h4>
          <div class="right">
            <div class="watched">
              <i></i>
              {{ data.click_num }}
            </div>
            <div class="praise" @click="praised(data, index)">
              <i :class="data.is_favorite == 0 ? 'unfav' : 'faved'"></i>
              {{ data.favorite_num }}
            </div>
          </div>
        </div>
        <div class="audio-row" v-show="data.audio_url">
          <audio
            :src="data.audio_url"
            v-on:ended="audio_end(data, index)"
            :error="audio_error"
          ></audio>
          <div class="audio-img">
            <i></i>
            {{ $t("columnVideo.Audio") }}
          </div>
          <input
            type="checkbox"
            class="audio-ctr play"
            @click="change(data, index)"
          />
          <div class="current-time" v-if="data.currentTime == -1">00:00</div>
          <div class="current-time" v-else>{{ data.currentTime }}</div>
          <div
            class="progress-bar-bg progressBarBg"
            @mousedown="progress($event, data, index)"
          >
            <span
              class="progressDot"
              :style="{ left: data.value * 100 + '%' }"
              v-if="data.value != -1"
            ></span>
            <span class="progressDot" v-else></span>
            <div
              class="progress-bar progressBar"
              :style="{ width: data.value * 100 + '%' }"
              v-if="data.value != -1"
            ></div>
            <div class="progress-bar progressBar" v-else></div>
          </div>
          <div class="duration" v-if="data.duration == -1"></div>
          <div class="duration" v-else>{{ data.duration }}</div>
        </div>
      </div>
      <div class="more" @click="go_list(data, index)">
        {{ $t("columnVideo.seeMore") }}
      </div>
      <div class="line"></div>
    </div>
    <div class="fixed-video-box" v-if="video_show" @touchmove.prevent>
      <div class="box-pos">
        <MyAliplayer
          :video1="video"
          :videoHeight="videoHeight"
          :videoDetail="videoDetail"
          :video_id="video_id"
          :column_id="column_id"
        ></MyAliplayer>
        <div class="close-img" @click="close"></div>
      </div>
    </div>
  </div>
</template>
<script>
import MyAliplayer from "../../components/MyAliplayer/index_column_video";
import { mapState } from "vuex";
import mixin from "./mixins";

export default {
  data() {
    return {
      datas: [],
      video_show: false,
      video: {
        VideoId: 1,
        source:
          "https://vod.olympicchannel.com/NBCR_Production_-_OCS/233/968/GEPH-ONTHERECS02E015C-_E17101101_master.m3u8",
        Duration: "04:11",
      },
      videoHeight: "3.6rem",
      videoDetail: "",
      video_id: "",
      column_id: "",
      repeat_praise: true,
      localData: {},
    };
  },
  mixins: [mixin],
  computed: {
    ...mapState({
      watched_num: (state) => state.column_video.watched_num,
      fromid: (state) => state.column_video.fromid,
      is_favorite: (state) => state.column_video.is_favorite,
      is_watched: (state) => state.column_video.is_watched,
      is_watch: (state) => state.column_video.is_watch,
    }),
  },
  watch: {
    datas() {
      this.$nextTick(() => {
        // console.log('nextTick');
        let rem = parseFloat(this.getRem());
        // console.log("watch 中的rem", rem);
        if (this.datas != undefined) {
          for (var i = 0; i < this.datas.length; i++) {
            let descHeight = window
              .getComputedStyle(this.$refs.desc[i])
              .height.replace("px", "");
            // console.log(descHeight);
            if (descHeight > 2 * rem) {
              // 显示展开收起按钮
              $(".fold").eq(i).show();
            } else {
              // 不显示展开收起按钮
              $(".fold").eq(i).hide();
            }
          }
        }
      });
    },
  },
  components: {
    MyAliplayer,
  },
  created() {
    // this.$i18n.locale = "zh";
    this.get_column_video();
  },
  activated() {
    if (this.datas.length != 0) {
      this.datas.forEach((value) => {
        if (this.fromid == value.tags_id) {
          if (this.watched_num != 0) {
            value.click_num = value.click_num + this.watched_num;
          }
          if (this.is_favorite != -1) {
            if (this.is_favorite == 1) {
              value.is_favorite = 1;
              value.favorite_num = value.favorite_num + 1;
            } else if (this.is_favorite == 0) {
              value.is_favorite = 0;
              value.favorite_num = value.favorite_num - 1;
            }
            this.$store.commit("column_video/is_favorite", -1);
          }
          if (this.is_watched == 1 && value.is_watched != 1) {
            value.is_watched = 1;
          }
          if (this.is_watch == 1 && value.is_watch != 1) {
            value.is_watch = 1;
          }
        }
      });
      // 把所有的暂停按钮改为播放按钮
      var all_row = $(".audio-row");
      for (var i = 0; i < all_row.length; i++) {
        all_row.eq(i).find(".audio-ctr").removeClass("paused").addClass("play");
        all_row.eq(i).find("input[type=checkbox]")[0].checked = false;
      }
    }
    // 页面失去焦点
    window.onblur = () => {
      this.closeAllAudio();
    };
    // 判断当前页面是否被激活或浏览器进入后台运行
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        this.closeAllAudio();
      }
    });
  },
  methods: {
    getRem() {
      const defaultRem = 16;
      let winWidth = window.innerWidth;
      // console.log("winWidth:" + winWidth);
      let rem = (winWidth / 375) * defaultRem;
      return rem;
    },
    get_column_video() {
      var url = "index.php/mobile/index/column-list";
      var params = {
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: localStorage.getItem("_sys_id"),
        language: localStorage.getItem("_user_data_language"),
        type: 14,
      };
      this.$axios.post(url, params).then((res) => {
        // console.log(res);
        if (res.data.code == 0) {
          this.datas = res.data.result.data;
          if (this.datas != undefined) {
            for (var i = 0; i < this.datas.length; i++) {
              this.datas[i]["is_watch"] = 0;
              // console.log( localStorage.getItem(
              //     "video_" + this.datas[i].tags_id+"_"+ this.datas[i].resources_id
              //   )!=null );
              if (
                localStorage.getItem(
                  "video_" +
                    this.datas[i].tags_id +
                    "_" +
                    this.datas[i].resources_id
                ) != null
              ) {
                // 为true时
                var localDtata = JSON.parse(
                  localStorage.getItem(
                    "video_" +
                      this.datas[i].tags_id +
                      "_" +
                      this.datas[i].resources_id
                  )
                );
                this.datas[i]["duration"] = localDtata.duration;
                this.datas[i]["currentTime"] = localDtata.currentTime;
                this.datas[i]["value"] = localDtata.value;
              } else {
                this.datas[i]["duration"] = -1;
                this.datas[i]["currentTime"] = -1;
                this.datas[i]["value"] = -1;
              }
            }
          }
        } else {
          if (res.data.code == 10600) {
            this.$router.push({ name: "Login" });
          } else {
            this.$toast(res.data.msg);
          }
        }
      });
    },
    watch(data, index) {
      if (data.res_time_status == "3") {
        return this.$toast(this.$t("learningCamp.ResourcesExpired"));
      } else if (data.res_time_status == "1") {
        return this.$toast("资源未生效");
      } else if (data.res_time_status == "4") {
        return this.$toast("资源未授权或资源已删除");
      }
      // 停止音频
      // 暂停播放所有音频
      this.closeAllAudio();
      // 遮盖层
      this.video_show = true;
      this.add_click(data, index);
      this.videoDetail = data.resource_hash;
      this.video_id = data.resources_id;
      this.column_id = data.tags_id;
      // this.$store.commit("column_video/videoUrl", data.resource_hash);
    },
    close() {
      this.video_show = false;
    },
    add_click(data) {
      var url = "index.php/mobile/column/add-click-num";
      var params = {
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: localStorage.getItem("_sys_id"),
        language: localStorage.getItem("_user_data_language"),
        resources_id: data.resources_id,
      };
      this.$axios.post(url, params).then((res) => {
        // console.log(res);
        if (res.data.code == 0) {
          data.click_num++;
        } else {
          if (res.data.code == 10600) {
            this.$router.push({ name: "Login" });
          } else {
            this.$toast(res.data.msg);
          }
        }
      });
    },
    showTotalIntro(index) {
      // 背景图的切换
      $(".fold").eq(index).toggleClass("unfold");
      // 展开，收起
      $(".fold").eq(index).find("span").text() == this.$t("columnVideo.more")
        ? $(".fold")
            .eq(index)
            .find("span")
            .text(this.$t("columnVideo.collapse"))
        : $(".fold").eq(index).find("span").text(this.$t("columnVideo.more"));
      // 内容切换
      if ($(".showtotal").eq(index).hasClass("detailed-introduce")) {
        $(".showtotal")
          .eq(index)
          .removeClass("detailed-introduce")
          .addClass("total-introduce");
      } else {
        $(".showtotal")
          .eq(index)
          .removeClass("total-introduce")
          .addClass("detailed-introduce");
      }
    },
    praised(data, index) {
      if (this.repeat_praise) {
        this.repeat_praise = false;

        var url = "index.php/mobile/favorite/item";
        var params = {
          sys_id: localStorage.getItem("_sys_id"),
          user_id: localStorage.getItem("_user_data_id"),
          company_id: localStorage.getItem("_user_data_company_id"),
          sso_token: localStorage.getItem("_user_data_sso_token"),
          language: localStorage.getItem("_user_data_language"),
          item: data.resources_id,
          type: 14,
        };
        this.$axios.post(url, params).then((res) => {
          // console.log(res);
          this.repeat_praise = true;
          if (res.data.code == 0) {
            if (res.data.result.is_favorite == 1) {
              this.$toast(this.$t("columnVideo.success"));
              this.datas[index].is_favorite = 1;
              this.datas[index].favorite_num++;
            } else {
              this.$toast(this.$t("columnVideo.del"));
              if (this.datas[index].favorite_num > 0) {
                this.datas[index].favorite_num--;
              } else {
                this.datas[index].favorite_num = 0;
              }
              this.datas[index].is_favorite = 0;
            }
          } else {
            if (res.data.code == 10600) {
              this.$router.push({ name: "Login" });
            } else {
              this.$toast(res.data.msg);
            }
          }
        });
      }
    },
    change(data, index) {
      var checked_row = $(".audio-row")
        .eq(index)
        .find("input[type=checkbox]")[0].checked;
      var all_row = $(".audio-row");
      if (checked_row) {
        for (var i = 0; i < all_row.length; i++) {
          all_row
            .eq(i)
            .find(".audio-ctr")
            .removeClass("paused")
            .addClass("play");
          all_row.eq(i).find("input[type=checkbox]")[0].checked = false;
          // 暂停播放音频
          if (!$("audio").get(i).paused) {
            $("audio").get(i).pause();
          }
        }

        var playPromise = $("audio").get(index).play();

        if (playPromise != undefined) {
          if (this.startSeekTime !== null) {
            this.submitStudyTime(this.video_id);
          } else {
            this.timerFun();
          }
          this.video_id = data.resources_id;
          this.seekTimer = 0;
          this.startSeekTime = Date.parse(new Date()) / 1000;

          playPromise
            .then(() => {
              // 记录状态
              if (
                localStorage.getItem(
                  "video_" + data.tags_id + "_" + data.resources_id
                ) != null
              ) {
                if (
                  JSON.parse(
                    localStorage.getItem(
                      "video_" + data.tags_id + "_" + data.resources_id
                    )
                  ).currentTime != -1
                ) {
                  $("audio").get(index).currentTime = parseInt(
                    this.timeToSeconds(
                      JSON.parse(
                        localStorage.getItem(
                          "video_" + data.tags_id + "_" + data.resources_id
                        )
                      ).currentTime
                    )
                  );
                }
              }
              $(".audio-row")
                .eq(index)
                .find(".audio-ctr")
                .removeClass("play")
                .addClass("paused");
              $(".audio-row")
                .eq(index)
                .find("input[type=checkbox]")[0].checked = true;
              // 音频播放增加一次
              this.add_click(data, index);
              $(".duration")
                .eq(index)
                .text(this.secondsToTime($("audio").get(index).duration));
              this.localData.duration = this.secondsToTime(
                $("audio").get(index).duration
              );
              // 进度条
              var current_audio = $("audio").get(index);
              current_audio.addEventListener("timeupdate", () => {
                $(".current-time")
                  .eq(index)
                  .text(this.secondsToTime($("audio").get(index).currentTime));
                this.localData.currentTime = this.secondsToTime(
                  $("audio").get(index).currentTime
                );
                var value = current_audio.currentTime / current_audio.duration;
                this.localData.value = value;
                $(".progressBar")
                  .eq(index)
                  .css("width", value * 100 + "%");
                $(".progressDot")
                  .eq(index)
                  .css("left", value * 100 + "%");
                localStorage.setItem(
                  "video_" + data.tags_id + "_" + data.resources_id,
                  JSON.stringify(this.localData)
                );
              });
            })
            .catch(() => {
              this.$toast(this.$t("columnVideo.error"));
            });
        }
      } else {
        if (this.startSeekTime !== null) {
          this.submitStudyTime(data.resources_id);
        }
        this.seekTimer = 0;
        this.startSeekTime = null;
        this.clearTimer();

        $(".audio-row")
          .eq(index)
          .find(".audio-ctr")
          .removeClass("paused")
          .addClass("play");
        $(".audio-row")
          .eq(index)
          .find("input[type=checkbox]")[0].checked = false;
        // 暂停播放音频
        $("audio").get(index).pause();
      }
    },
    secondsToTime(secs) {
      var hoursDiv = secs / 3600;
      var hours = Math.floor(hoursDiv);
      var minutesDiv = (secs % 3600) / 60;
      var minutes = Math.floor(minutesDiv);
      var seconds = Math.ceil((secs % 3600) % 60);
      if (seconds > 59) {
        seconds = 0;
        minutes = Math.ceil(minutesDiv);
      }
      if (minutes > 59) {
        minutes = 0;
        hours = Math.ceil(hoursDiv);
      }
      if (isNaN(hours)) {
        return "";
      }
      return (
        (hours == 0
          ? ""
          : hours > 0 && hours.toString().length < 2
          ? "0" + hours + ":"
          : hours + ":") +
        (minutes.toString().length < 2 ? "0" + minutes : minutes) +
        ":" +
        (seconds.toString().length < 2 ? "0" + seconds : seconds)
      );
    },
    timeToSeconds(time) {
      var s = null;
      if (time.split(":").length == 3) {
        let hour = time.split(":")[0];
        let min = time.split(":")[1];
        let sec = time.split(":")[2];
        s = Number(hour * 3600) + Number(min * 60) + Number(sec);
      } else if (time.split(":").length == 2) {
        let min = time.split(":")[0];
        let sec = time.split(":")[1];
        s = Number(min * 60) + Number(sec);
      }
      return s;
    },
    progress(e, data, index) {
      // 点击进度条跳到指定点播放
      // PS：此处不要用click，否则下面的拖动进度点事件有可能在此处触发，此时e.offsetX的值非常小，会导致进度条弹回开始处（简直不能忍！！）
      var _this = this;
      // 只有音乐开始播放后才可以调节，已经播放过但暂停了的也可以
      if ($(".audio-row").eq(index).find(".audio-ctr").hasClass("paused")) {
        var pgsWidth = $(".progress-bar-bg").eq(index).width();
        var rate = e.offsetX / pgsWidth;
        $(".progressBar")
          .eq(index)
          .css("width", rate * 100 + "%");
        $(".progressDot")
          .eq(index)
          .css("left", rate * 100 + "%");
        // console.log(Math.floor($('audio').get(index).duration * rate))
        $("audio").get(index).currentTime = Math.floor(
          $("audio").get(index).duration * rate
        );
        this.localData.currentTime = Math.floor(
          $("audio").get(index).duration * rate
        );
        localStorage.setItem(
          "video_" + data.tags_id + "_" + data.resources_id,
          JSON.stringify(_this.localData)
        );
      }
    },
    audio_end(data, index) {
      if (this.startSeekTime !== null) {
        this.submitStudyTime(data.resources_id);
      }
      this.seekTimer = 0;
      this.startSeekTime = null;
      this.clearTimer();

      $(".audio-row")
        .eq(index)
        .find(".audio-ctr")
        .removeClass("paused")
        .addClass("play");
      $(".audio-row").eq(index).find("input[type=checkbox]")[0].checked = false;
      // $(".progressBar")
      //   .eq(index)
      //   .css("width", "0");
      // $(".progressDot")
      //   .eq(index)
      //   .css("left", "0");
      this.localData.currentTime = -1;
      this.localData.value = -1;
      localStorage.setItem(
        "video_" + data.tags_id + "_" + data.resources_id,
        JSON.stringify(this.localData)
      );
    },
    audio_error() {},
    go_list(data) {
      this.$router.push({
        path: "/main/columnVideoList",
        query: {
          id: data.tags_id,
        },
      });
    },
    // 关闭所有音频
    closeAllAudio() {
      var all_row = $(".audio-row");
      for (var i = 0; i < all_row.length; i++) {
        all_row.eq(i).find(".audio-ctr").removeClass("paused").addClass("play");
        all_row.eq(i).find("input[type=checkbox]")[0].checked = false;
        // 暂停播放音频
        if (!$("audio").get(i).paused) {
          $("audio").get(i).pause();
          // 提交学时
          if (this.startSeekTime !== null) {
            this.submitStudyTime(this.datas[i].resources_id);
          }
          this.seekTimer = 0;
          this.startSeekTime = null;
          this.clearTimer();
        }
      }
    },
  },
  deactivated() {
    this.closeAllAudio();
  },
};
</script>
<style scoped lang="less">
.column-video {
  width: 100%;
  height: 100%;
  background: #fff;
  .title {
    font-size: 0.28rem;
    text-align: center;
    color: #666;
    padding: 0.2rem;
    border-bottom: 1px solid #ddd;
    i {
      display: inline-block;
      width: 0.23rem;
      height: 0.03rem;
      background: #999;
      vertical-align: middle;
    }
  }
  .more {
    font-size: 0.22rem;
    color: #225587;
    text-align: center;
    padding: 0.2rem;
    border-top: 1px solid #ddd;
  }
  .line {
    height: 0.2rem;
    background: #f6f6f6;
  }
  .content {
    margin: 0.1rem 0.1rem 0.2rem;
    padding-bottom: 0.38rem;
    // background: #f6f6f6;
    .content-img {
      padding: 0.2rem 0.2rem 0.35rem 0.2rem;
      position: relative;
      img {
        width: 100%;
        height: 3.55rem;
      }
      .watched {
        color: #fff;
        font-size: 0.2rem;
        position: absolute;
        top: 0.6rem;
        background: #4aa854;
        padding: 0.05rem 0.2rem;
        border-radius: 0 2rem 2rem 0;
      }
      .play {
        width: 1.14rem;
        height: 1.14rem;
        background: url("../../assets/img/column_video/play.png") no-repeat
          center/contain;
        background-size: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -0.57rem;
        margin-left: -0.57rem;
      }
      .replay {
        width: 1.14rem;
        height: 1.14rem;
        background: url("../../assets/img/column_video/replay.png") no-repeat
          center/contain;
        background-size: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -0.57rem;
        margin-left: -0.57rem;
      }
    }
    h1 {
      margin: 0 0.2rem;
      font-size: 0.3rem;
      font-weight: bold;
    }
    h2 {
      margin: 0.1rem 0.2rem;
      font-size: 0.22rem;
      vertical-align: middle;
      color: #666;
      i {
        margin: 0 0.2rem;
      }
    }
    .total-introduce {
      height: auto;
      overflow: hidden;
      font-size: 0.26rem;
      margin: 0 0.2rem;
      .intro-content {
        .merchant-desc {
          width: 100%;
          line-height: 0.4rem;
        }
      }
    }
    .detailed-introduce {
      font-size: 0.26rem;
      overflow: hidden;
      margin: 0.1rem 0.2rem;
      position: relative;
      .intro-content {
        // 最大高度设为2倍的行间距
        max-height: 0.8rem;
        line-height: 0.4rem;
        word-wrap: break-word;
        /*强制打散字符*/
        word-break: break-all;
        overflow: hidden;
        .merchant-desc {
          width: 100%;
          line-height: 0.4rem;
        }
        &:after,
      // 这是展开前实际显示的内容
      &:before {
          content: attr(title);
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
        }
        // 把最后最后一行自身的上面三行遮住
        &:before {
          display: block;
          overflow: hidden;
          max-height: 0.8rem;
        }
        &:after {
          overflow: hidden;
          height: 0.8rem;
          background: #fff;
          display: -webkit-box;
          /*! autoprefixer: off */
          -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
          /* autoprefixer: on */

          /*截取行数*/
          -webkit-line-clamp: 2;
          text-overflow: ellipsis;
          /*! autoprefixer: off */
          -webkit-box-sizing: border-box;
          /* autoprefixer: on */
          box-sizing: border-box;
          /*尾部留空字符数*/
          padding-right: 0.5em;
        }
      }
    }
    .fold {
      z-index: 11;
      margin: 0 0.2rem;
      i {
        display: inline-block;
        width: 0.1rem;
        height: 0.1rem;
        background: url("../../assets/img/column_video/show.png") no-repeat 0;
        background-size: 100%;
        vertical-align: middle;
        margin-top: -0.02rem;
      }
      span {
        color: #005587;
        font-size: 0.22rem;
      }
    }
    .unfold {
      i {
        background: url("../../assets/img/column_video/hide.png") no-repeat 0;
        background-size: 100%;
      }
    }
    .info {
      margin: 0.2rem 0.2rem 0 0.2rem;
      padding-bottom: 0.2rem;
      display: flex;
      justify-content: space-between;
      h4 {
        font-size: 0.22rem;
        color: #666;
      }
      .right {
        display: flex;
        justify-content: center;
        font-size: 0.22rem;
        .watched {
          margin-right: 0.2rem;
          min-width: 0.6rem;
          i {
            display: inline-block;
            width: 0.3rem;
            height: 0.25rem;
            background: url("../../assets/img/column_video/watched.png")
              no-repeat center/contain;
            background-size: 100%;
            margin-top: -0.05rem;
            vertical-align: middle;
          }
        }
        .praise {
          min-width: 0.6rem;
          i {
            display: inline-block;
            width: 0.22rem;
            height: 0.25rem;
          }
          .unfav {
            background: url("../../assets/img/column_video/unfav.png") no-repeat
              center/contain;
            background-size: 100%;
            margin-top: -0.05rem;
            vertical-align: middle;
          }
          .faved {
            background: url("../../assets/img/column_video/faved.png") no-repeat
              center/contain;
            background-size: 100%;
            margin-top: -0.05rem;
            vertical-align: middle;
          }
        }
      }
    }
    .audio-row {
      margin: 0 0.3rem;
      padding: 0.15rem 0.05rem;
      border-radius: 0.1rem;
      background: #f6f6f6;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .duration {
        min-width: 0.5rem;
      }
      .audio-img {
        font-size: 0.22rem;
        color: #252631;
        i {
          display: inline-block;
          width: 0.23rem;
          height: 0.23rem;
          background: url("../../assets/img/column_video/volume.png") no-repeat
            center/contain;
          background-size: 100%;
          vertical-align: middle;
          margin-top: -0.05rem;
        }
      }
      .audio-ctr {
        width: 0.55rem;
        height: 0.56rem;
        margin: 0 0.05rem;
        border: none;
      }
      .play {
        background: url("../../assets/img/column_video/audio_play.png")
          no-repeat center/contain;
        background-size: 100%;
      }
      .paused {
        background: url("../../assets/img/column_video/audio_pause.png")
          no-repeat center/contain;
        background-size: 100%;
      }
      .progress-bar-bg {
        display: inline-block;
        width: 3rem;
        height: 0.05rem;
        background: #b5b8b9;
        border-radius: 0.02rem;
        position: relative;
        .progress-bar {
          width: 0;
          height: 0.05rem;
          background: #005587;
        }
        span {
          content: "";
          width: 0.2rem;
          height: 0.2rem;
          border-radius: 50%;
          background-color: #005587;
          position: absolute;
          left: 0;
          top: 50%;
          margin-top: -0.1rem;
          margin-right: -0.1rem;
        }
      }
    }
  }
  .fixed-video-box {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 100000;
    .box-pos {
      margin-top: 50%;
      .close-img {
        width: 1rem;
        height: 1rem;
        background: url("../../assets/img/column_video/close@3x.png") no-repeat
          center/contain;
        background-size: 100%;
        margin: 1rem auto;
      }
    }
  }
}
</style>
